import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API, formatDate } from "@/lib/api";
import { Coffee, ForkKnife, IdentificationCard, ArrowRight } from "@phosphor-icons/react";

export default function GuestPortal() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${API}/public/guest/${token}`)
      .then(r => setData(r.data))
      .catch(e => setErr(e.response?.data?.detail || "Ungültiger Link"));
  }, [token]);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="msb-card max-w-md"><h2 className="text-xl font-semibold">Fehler</h2><p className="text-sm mt-2">{err}</p></div>
    </div>
  );
  if (!data) return null;

  const items = [
    { to: `/check-in/${token}`, icon: IdentificationCard,
      title: "Online Check-in", desc: "Meldeschein & persönliche Daten hinterlegen",
      done: data.checkin_completed, testid: "portal-checkin" },
    { to: `/fruehstueck/${token}`, icon: Coffee,
      title: "Frühstück bestellen", desc: "19,99 € pro Person · frisch, regional & mit Bio-Produkten",
      testid: "portal-breakfast" },
    { to: `/essen/${token}`, icon: ForkKnife,
      title: "Mittag- oder Abendessen", desc: "19,99 € pro Person · hausgemacht mit Bio-Zutaten & Liebe",
      testid: "portal-meal" },
  ];

  return (
    <div className="min-h-screen py-10 px-4 bg-background">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="text-center">
          <div className="text-primary font-bold text-lg" style={{fontFamily:"'Work Sans',sans-serif"}}>MainSpessartBlick</div>
          <h1 className="text-3xl font-bold mt-2" style={{fontFamily:"'Work Sans',sans-serif"}}>
            Herzlich willkommen{data.guest.first_name ? `, ${data.guest.first_name}` : ""}
          </h1>
          <p className="text-muted-foreground mt-1">Ihr persönlicher Gästebereich</p>
        </div>

        <div className="msb-card grid grid-cols-2 gap-3 text-sm">
          <div><div className="text-xs uppercase text-muted-foreground">Zimmer</div><div>{data.booking.room}</div></div>
          <div><div className="text-xs uppercase text-muted-foreground">Nächte</div><div>{data.booking.nights}</div></div>
          <div><div className="text-xs uppercase text-muted-foreground">Anreise</div><div>{formatDate(data.booking.check_in)}</div></div>
          <div><div className="text-xs uppercase text-muted-foreground">Abreise</div><div>{formatDate(data.booking.check_out)}</div></div>
        </div>

        <div className="space-y-3">
          {items.map(i => (
            <Link key={i.to} to={i.to} data-testid={i.testid}
                  className="msb-card flex items-center gap-4 hover:bg-primary/5 transition-colors">
              <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center text-primary shrink-0">
                <i.icon size={24} weight="duotone"/>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold" style={{fontFamily:"'Work Sans',sans-serif"}}>{i.title}</div>
                <div className="text-xs text-muted-foreground">{i.desc}</div>
                {i.done && <div className="text-xs text-emerald-700 mt-1">✓ bereits erledigt</div>}
              </div>
              <ArrowRight size={20} className="text-muted-foreground"/>
            </Link>
          ))}
        </div>

        <div className="text-center text-xs text-muted-foreground pt-4">
          Bei Fragen erreichen Sie uns jederzeit über <a href="https://mainspessartblick.de" className="text-primary underline">mainspessartblick.de</a>.
        </div>
      </div>
    </div>
  );
}
